import React, { useEffect } from 'react'
import { FaqSection, Header, Footer } from '@wallyhealth/web-core'
import intelService from '../../services/intelService'
import HeroSection from './HeroSection'
import StepsSection from './StepsSection'
import SafetySection from './SafetySection'
import faqs from './faqs.json'
import styles from './index.module.css'

const WhiteningPage = () => {
  useEffect(() => {
    intelService.recordView({ viewName: 'WhiteningPage' })
  }, [])

  return (
    <div className={styles.container}>
      <Header />
      <HeroSection />
      <StepsSection />
      <SafetySection />
      <FaqSection items={faqs} />
      <Footer />
    </div>
  )
}

export default WhiteningPage
